import serviceRequest from "utils/request";

const API_URL = "/api/institution-mapping";

/**
 * Get Institution and Service Mapping list
 * @returns {Promise}
 */
export const getInstitutionServiceMapping = () => {
	return serviceRequest({
		url: `${API_URL}/service`,
		method: "get",
	});
};

/**
 * Get Institution and Site Access Mapping list
 * @returns {Promise}
 */
export const getInstitutionSiteAccessMapping = () => {
	return serviceRequest({
		url: `${API_URL}/site-access`,
		method: "get",
	});
};

/**
 * Get Institution Admin Mapping list
 * @returns {Promise}
 */
export const getInstitutionAdminMapping = () => {
	return serviceRequest({
		url: `${API_URL}/admin`,
		method: "get",
	});
};
